export default __webpack_public_path__ + "static/media/blueDropDown.a7c590c3.svg";